import {
  CourtDecision,
  CourtDecisionType,
  CourtLevelBaseData,
  CourtTypeBaseData,
  CrimeCategoryBaseData,
  CrimeTypeBaseData,
  ExibitCourtDecisionType,
  ExibitProsecutionDecisionType,
  PettyOffenceDecisionTypeList,
  ProsecutorDecisionBaseData,
} from "types";
import apiClient from "../lib/apiClients";

// CourtType
export const fetchCrimeType = async () => {
  const response = await apiClient.get<CrimeTypeBaseData[]>(
    "/base_data/crime-types/"
  );
  return response.data;
};
export const addCrimeType = async (data: CrimeTypeBaseData) => {
  const response = await apiClient.post("/base_data/crime-types/", data);
  return response.data;
};

// CourtLevel
export const fetchCourtLevel = async () => {
  const response = await apiClient.get<CourtLevelBaseData[]>(
    "/base_data/court-levels/"
  );
  return response.data;
};
export const addCourtLevel = async (data: CourtLevelBaseData) => {
  const response = await apiClient.post("/base_data/court-levels/", data);
  return response.data;
};

// CrimeCategory
export const fetchCrimeCategoryBaseData = async () => {
  const response = await apiClient.get<CrimeCategoryBaseData[]>(
    "/base_data/crime-categories/"
  );
  return response.data;
};
export const addCrimeCategoryBaseData = async (data: CrimeCategoryBaseData) => {
  const response = await apiClient.post("/base_data/crime-categories/", data);
  return response.data;
};

// ProsecutorDecision
export const fetchProsecutorDecision = async () => {
  const response = await apiClient.get<ProsecutorDecisionBaseData[]>(
    "/base_data/prosecutor-decisions/"
  );
  return response.data;
};
export const addProsecutorDecision = async (
  data: ProsecutorDecisionBaseData
) => {
  const response = await apiClient.post(
    "/base_data/prosecutor-decisions/",
    data
  );
  return response.data;
};
// CourtDecision
export const fetchCourtDecision = async () => {
  const response = await apiClient.get<CourtDecision[]>(
    "/base_data/court_decision/"
  );
  return response.data;
};
export const addCourtDecision = async (data: CourtDecision) => {
  const response = await apiClient.post("/base_data/court_decision/", data);
  return response.data;
};
// CourtDecision
export const fetchCourtDecisionType = async () => {
  const response = await apiClient.get<CourtDecisionType[]>(
    "/base_data/court_decision_type/"
  );
  return response.data;
};
export const addCourtDecisionType = async (data: CourtDecisionType) => {
  const response = await apiClient.post(
    "/base_data/court_decision_type/",
    data
  );
  return response.data;
};
// ExhibitCondition
export const fetchExhibitConditions = async () => {
  const response = await apiClient.get<CourtDecisionType[]>(
    "/base_data/exhibit-conditions/"
  );
  return response.data;
};
// ExhibitProsecutorDecisionType
export const fetchExhibitProsecutorDecisionType = async () => {
  const response = await apiClient.get<ExibitProsecutionDecisionType[]>(
    "/base_data/exhibit-prosecution-decision-types/"
  );
  return response.data;
};
// ExhibitCourtDecisionType
export const fetchExhibitCourtDecisionType = async () => {
  const response = await apiClient.get<ExibitCourtDecisionType[]>(
    "/base_data/exhibit-court-decision-types/"
  );
  return response.data;
};
// PettyOffenceDecisionType
export const fetchPettyOffenceDecisionType = async () => {
  const response = await apiClient.get<PettyOffenceDecisionTypeList[]>(
    "/base_data/petty-offence/"
  );
  return response.data;
};
export const fetchCourtType = async () => {
  const response = await apiClient.get<CourtTypeBaseData[]>(
    "/base_data/court-types/"
  );
  return response.data;
};
